'use client';

import { c as _c } from "react/compiler-runtime";
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from '@uzh-bf/design-system';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { useState } from 'react';
import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';
import type { CourseUnitTimeProgress } from '~/app/actions/progress.server';
import { resetCourseBlockProgress } from '~/app/actions/unitProgress.server';
import { CACHE_KEYS } from '~/lib/cache';
import { useAuthToken } from '~/lib/hooks';
import { trackEvent } from '~/lib/matomo';
function ResetCourseBlockProgress() {
  const $ = _c(46);
  const {
    mutate
  } = useSWRConfig();
  const [isOpen, setIsOpen] = useState(false);
  const jwt = useAuthToken();
  const t = useTranslations();
  const params = useParams();
  let t0;
  if ($[0] !== mutate || $[1] !== params) {
    t0 = {
      onSuccess: () => {
        mutate(key => key?.includes(CACHE_KEYS.BLOCK_PROGRESS({
          courseId: params.courseId
        })) ?? false, _temp, {
          revalidate: false
        });
        mutate(CACHE_KEYS.COURSE_UNIT_TIME_PROGRESS({
          courseId: params.courseId
        }), _temp4, {
          revalidate: false
        });
        mutate(key_0 => key_0?.includes(CACHE_KEYS.BLOCK_PROGRESS({
          courseId: params.courseId
        })) || key_0?.includes(CACHE_KEYS.OBJECTIVE_PROGRESS({
          courseId: params.courseId
        })) || key_0?.includes(CACHE_KEYS.COURSE_UNIT_TIME_PROGRESS({
          courseId: params.courseId
        })));
        setIsOpen(false);
      }
    };
    $[0] = mutate;
    $[1] = params;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    trigger,
    isMutating
  } = useSWRMutation("resetCourseBlockProgress", resetCourseBlockProgress, t0);
  let t1;
  if ($[3] !== jwt || $[4] !== params || $[5] !== trigger) {
    t1 = async () => {
      if (!jwt) {
        return;
      }
      ;
      try {
        await trigger({
          courseId: Number(params.courseId),
          jwt
        });
        trackEvent({
          category: "progress",
          action: "reset_course_confirm",
          name: "success"
        });
      } catch (t2) {
        const error = t2;
        trackEvent({
          category: "progress",
          action: "reset_course_confirm",
          name: "failure"
        });
        console.error("[ResetCourseBlockProgress] Failed to reset course progress:", error);
      }
    };
    $[3] = jwt;
    $[4] = params;
    $[5] = trigger;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const handleConfirm = t1;
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsOpen(true);
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faArrowsRotate} />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t) {
    t4 = t("course.resetProgress");
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <button onClick={t2} className="flex h-8 w-max flex-row items-center justify-center gap-3 rounded border border-solid px-2 hover:bg-gray-50 transition-colors">{t3}<div>{t4}</div></button>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsOpen(false);
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("course.resetProgressQuestion");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t) {
    t8 = t("course.resetProgressEffect");
    $[16] = t;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <div className="mb-6"><p className="text-gray-700">{t8}</p></div>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(false);
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("generic.cancel");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== isMutating || $[24] !== t11) {
    t12 = <button onClick={t10} disabled={isMutating} className="px-4 py-2 rounded border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">{t11}</button>;
    $[23] = isMutating;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = !jwt || isMutating;
  let t14;
  if ($[26] !== isMutating || $[27] !== t) {
    t14 = isMutating ? `${t("generic.confirm")}...` : t("generic.confirm");
    $[26] = isMutating;
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== handleConfirm || $[30] !== t13 || $[31] !== t14) {
    t15 = <button onClick={handleConfirm} disabled={t13} className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">{t14}</button>;
    $[29] = handleConfirm;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t12 || $[34] !== t15) {
    t16 = <div className="flex justify-end gap-3">{t12}{t15}</div>;
    $[33] = t12;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t16 || $[37] !== t9) {
    t17 = <div className="p-6">{t9}{t16}</div>;
    $[36] = t16;
    $[37] = t9;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== isOpen || $[40] !== t17 || $[41] !== t7) {
    t18 = <Modal open={isOpen} onClose={t6} title={t7}>{t17}</Modal>;
    $[39] = isOpen;
    $[40] = t17;
    $[41] = t7;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t18 || $[44] !== t5) {
    t19 = <>{t5}{t18}</>;
    $[43] = t18;
    $[44] = t5;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  return t19;
}
function _temp4(prev_0) {
  return prev_0 ? {
    ...prev_0,
    completedMinutes: 0,
    completedUnits: 0,
    progressPercentage: 0,
    unitCompletedMinutes: Object.keys(prev_0.unitCompletedMinutes ?? {}).reduce(_temp2, {}),
    moduleCompletedMinutes: Object.keys(prev_0.moduleCompletedMinutes ?? {}).reduce(_temp3, {})
  } : prev_0;
}
function _temp3(acc_0, moduleId) {
  acc_0[Number(moduleId)] = 0;
  return acc_0;
}
function _temp2(acc, unitId) {
  acc[Number(unitId)] = 0;
  return acc;
}
function _temp(prev) {
  if (typeof prev === "number") {
    return 0;
  }
  if (!prev || typeof prev !== "object") {
    return prev;
  }
  return {
    ...prev,
    completedBlocks: [],
    onceCompletedBlocks: [],
    checkedObjectives: [],
    time: 0,
    progressPercentage: 0
  };
}
export default ResetCourseBlockProgress;